import { Component, effect, EventEmitter, Output } from '@angular/core';
import { ResultadosService } from '../../../resultados/resultados.service';
import { SeguradoraResultFilter } from '../../../resultados/resultados';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';

@Component({
  selector: 'filtro-resultados',
  templateUrl: './resultados.component.html',
  styleUrls: ['./resultados.component.scss'],
  imports: [CommonModule, ModulosDeFormulario],
})
export class ResultadosComponent {
  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();

  seguradorasList: SeguradoraResultFilter[] = [];
  seguradorasFilteredList: SeguradoraResultFilter[] = [];
  checkedAll: boolean = true;
  resultTipo: string;
  private isUpdatingFilters = false;

  constructor(
    public resultadosService: ResultadosService,
    private filtroController: FiltroControllerService
  ) {
    this.initializeFiltros();

    effect(() => {
      if (this.isUpdatingFilters) return;

      const seguradorasFilteredList =
        this.resultadosService.seguradorasFilterList();

      if (seguradorasFilteredList) {
        this.seguradorasList = seguradorasFilteredList;
        this.seguradorasFilteredList = seguradorasFilteredList;

        this.verificaCheckedAll();
      }

      const resultTipo = this.resultadosService.resultTipo();

      if (resultTipo && resultTipo !== this.resultTipo) {
        this.resultTipo = this.resultadosService.resultTipo();

        this.resetFilterSeguradoras();
      }
    });
  }

  initializeFiltros = () => {
    this.resultTipo = this.resultadosService.resultTipo();
  };

  verificaCheckedAll = () => {
   const temAlgumMarcado = this.seguradorasList.some((value) => value.checked);
    this.checkedAll = !temAlgumMarcado;
  };

  toggleAllSeguradoras = (checked: boolean) => {
    if (checked) {
      this.seguradorasList.map((seg) => (seg.checked = false));
      this.seguradorasFilteredList.map((seg) => (seg.checked = false));
      this.checkedAll = true;
    } else {
      this.checkedAll = false;
    }    
    this.buildString();
  };

  checkAll = (checked: boolean) => {
    this.seguradorasFilteredList.map((seg) => (seg.checked = checked));
    this.seguradorasList.map((seg) => (seg.checked = checked));
    this.buildString(); // Aplica o filtro automaticamente
  };

  changeCheckSeguradora = (checked: boolean, selectSeguradora) => {
    this.seguradorasFilteredList.map((seg) => {
      if (seg === selectSeguradora) {
        seg.checked = checked;
      }
    });

    this.seguradorasList.map((seg) => {
      if (seg === selectSeguradora) {
        seg.checked = checked;
      }
    });

    if (checked) {
      this.checkedAll = false;
    }

    this.verificaCheckedAll();
    this.buildString();
  };

  resetFilterSeguradoras = () => {
    this.seguradorasList.map((seg) => (seg.checked = false));
    this.seguradorasFilteredList.map((seg) => (seg.checked = false));
    this.verificaCheckedAll();
  };

  clearFilter = () => {
    this.resetFilterSeguradoras();
    this.filtroController.limparFiltro('resultados');
    this.buildString(true);
    this.limpaFiltro.emit();
    this.filtroController.verificaFiltro();
  };

  buildString = (clean = false) => {
    this.verificaCheckedAll();

    this.filtroController.updateActiveFilters("seguradoras", this.seguradorasFilteredList?.filter((seg) => seg.checked)?.length ?? 0);

    let filtro = {
      values: clean ? null : this.seguradorasList,
    };

    this.filtroController.addFiltrosExtras('resultados', filtro);
    this.eventFilter.emit(filtro);
    
    this.isUpdatingFilters = true;
    this.resultadosService.seguradorasFilterList.set(
      this.seguradorasList
    );
    
    setTimeout(() => {
      this.isUpdatingFilters = false;
    }, 10);

    return filtro;
  };

  onBuscaChange(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    const searchValue = input.value.toLowerCase().trim();

    if (searchValue.length > 0)
      this.seguradorasFilteredList = this.seguradorasList.filter((seguradora) =>
        seguradora?.nome?.toLowerCase().trim().startsWith(searchValue)
      );

    if (searchValue.length == 0)
      this.seguradorasFilteredList = this.seguradorasList;
  }
}
